<template>
  <div id="university" class="margin-subpages">
    <div class="pt-24 px-20 pb-16 hv-chart-card">
      <div class="sub-title px-12">
        <span class="fs-24">{{
          $utils("addCommasInNumber", university_total)
        }}</span>
        {{ $t("happilyVillage.learning_and_activity_interactions") }}
      </div>
      <div class="relative" style="height: 240px">
        <div class="center absolute-mid" v-if="loadingChartStatus">
          <loading-even></loading-even>
        </div>
        <canvas
          ref="universityBarchart"
          height="240px"
          class="barchart-style"
        ></canvas>
      </div>
    </div>
    <div id="universitySessions" class="mt-12">
      <el-tabs v-model="activeSubTab" class="university-tabs">
        <el-tab-pane name="sessions">
          <span slot="label" class="tab-label">{{ $t("happilyVillage.Sessions_tab") }}</span>
          <div class="sub-title pt-24">
            <span class="fs-24">{{
              $utils("addCommasInNumber", sessionResults)
            }}</span>
            {{ $t("happilyVillage.University_Sessions") }}
          </div>
      <div class="flex-row-between mt-14">
        <div class="relative">
          <el-input
            class="input-style"
            style="height: 40px"
            autosize
            :placeholder="$t('happilyVillage.Search')"
            @keyup.native="typeingSearchSession"
            v-model="inputSearchSession"
            clearable
          ></el-input>
          <!-- <img
            @click="exportTable('universitySesstions')"
            :src="$utils('icons', 'ic_xls_download')"
            class="icon-export"
          />-->
          <download-progress :active="downloadSessionsBar"></download-progress>
        </div>
        <div class="flex-center">
          <el-button
            class="btn-add small"
            size="small"
            icon="el-icon-plus"
            @click="addSession"
            >{{ $t("happilyVillage.add_session") }}</el-button
          >
        </div>
      </div>
      <div class="mt-12">
        <div class="university-table-wrapper">
          <el-table
            class="table-happily-village university-sessions-table"
            :data="sessions"
            style="width: 100%"
            @sort-change="sessionSort"
            :empty-text="
              loadingUniversitySessionsTable
                ? ' '
                : !loadingUniversitySessionsTable && inputSearchSession === ''
                ? $t('happilyVillage.No_sessions')
                : $t('happilyVillage.No_session_found')
            "
          >
          <el-table-column
            :label="$t('happilyVillage.Name')"
            sortable="custom"
            width="300"
            prop="class_name"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.huddles"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <span
                    v-for="(data, index) in scope.row.huddles"
                    :key="data.key"
                  >
                    <span v-if="index < 2" :class="`${spanBgColor(data)}`">{{
                      spanTextTag(data)
                    }}</span>
                    <span v-else-if="index == 2" class="span-tag span-normal"
                      >+ {{ scope.row.huddles.length - 2 }}</span
                    >
                  </span>
                </span>
                <span
                  @click.prevent="showCommentModal(scope.row)"
                  :style="$utils('fontStyle', scope.row.class_name)"
                  class="name-medium cursor-pointer"
                  >{{ scope.row.class_name }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_name"
            sortable="custom"
            :label="$t('happilyVillage.Creator')"
            width="105"
          >
            <template slot-scope="scope">
              <div class="ellipsis normal"
              :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.create_name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="topic_name"
            sortable="custom"
            :label="$t('happilyVillage.Topic')"
            width="100"
          >
            <template slot-scope="scope">
              <div
                class="ellipsis normal"
                :class="{ 'ml-10': !scope.row.topic_name }"
              >
                {{ scope.row.topic_name ? scope.row.topic_name : "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Sign_ups')"
            align="right"
            width="100"
            prop="signup"
          >
            <template slot-scope="scope">
              <div @click.prevent="SignUpsModal(scope.row)" class="link mr-10">
                {{ $utils("addCommasInNumber", scope.row.signup.length) }} /
                {{ $utils("addCommasInNumber", scope.row.class_limit) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Engagement')"
            align="right"
            width="125"
            prop="commentsall"
          >
            <template slot-scope="scope">
              <div
                @click.prevent="showCommentModal(scope.row)"
                class="normal mr-10 fc-00B7EE cursor-pointer underline"
              >
                {{ $utils("addCommasInNumber", scope.row.commentsall) }}
                {{ $t("happilyVillage.comment") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Price')"
            align="right"
            width="80"
            prop="class_price"
          >
            <template slot-scope="scope">
              <div class="normal mr-10">
                <template v-if="scope.row.class_price > 1"
                  >{{
                    $utils("addCommasInNumber", scope.row.class_price)
                  }}
                  {{ $t("happilyVillage.coins") }}</template
                >
                <template v-else-if="scope.row.class_price == 1"
                  >{{ $t("happilyVillage.one_coin") }}</template
                >
                <template v-else>{{ $t("happilyVillage.Free") }}</template>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            sortable="custom"
            :label="$t('happilyVillage.Date_and_Time')"
            align="right"
            width="165"
            prop="class_datetime"
          >
            <template slot-scope="scope">
              <div class="normal last">
                {{ removeYear(scope.row.class_datetime) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('happilyVillage.Actions')"
            width="90"
            align="center"
          >
            <template slot-scope="scope">
              <div class="campaign-actions-cell">
                <el-dropdown
                  trigger="click"
                  placement="bottom-end"
                  @command="handleSessionActionCommand($event, scope.row)"
                >
                  <button
                    type="button"
                    class="campaign-actions-trigger"
                    :title="$t('happilyVillage.Session_actions')"
                  >
                    <i class="el-icon-more"></i>
                  </button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="duplicate">{{ $t("happilyVillage.Duplicate") }}</el-dropdown-item>
                    <el-dropdown-item v-if="canEditPost(scope.row)" command="edit">{{ $t("happilyVillage.Edit") }}</el-dropdown-item>
                    <el-dropdown-item command="delete">{{ $t("happilyVillage.Delete") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        </div>
        <div
          class="center mt-20 mb-40 pt-20 pb-40"
          v-if="loadingUniversitySessionsTable"
        >
          <loading-even></loading-even>
        </div>
        <div class="flex-center pagination mt-10">
          <el-pagination
            @current-change="handleCurrentSessionChange"
            :current-page="1"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            :total="sessionResults"
          ></el-pagination>
          <span class="results-status"
            >{{ sessions.length > 10 ? 10 : sessions.length }}
            {{ $t("happilyVillage.results_from") }}
            {{ $utils("addCommasInNumber", sessionResults) }}
            {{ $t("happilyVillage.results") }}</span
          >
        </div>
      </div>
        </el-tab-pane>
        
        <el-tab-pane name="campaigns">
          <span slot="label" class="tab-label">{{ $t("happilyVillage.Campaigns_tab") }}</span>
          <university-campaigns v-if="activeSubTab === 'campaigns'" />
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="remove-padding-modal">
      <el-dialog :visible.sync="sessionModalStatus" width="930px" top="10vh">
        <div class="grid-2-sesstion">
          <div class="grid-left rm-scrollbar">
            <div class="aq-preview-eyebrow">{{ $t("happilyVillage.Preview_on_Mobile") }}</div>
            <div class="body">
              <div
                v-if="!$utils('watchingTrim', sessionForm.name)"
                class="bg-skeleton height-32"
              ></div>
              <div v-else class="fc-404243 fs-18 fw-900 word-break">
                {{ sessionForm.name.trim() }}
              </div>
              <div v-if="!sessionDescriptionStripped">
                <div class="bg-skeleton height-25 mt-24"></div>
                <div class="bg-skeleton height-25 mt-6"></div>
                <div
                  class="bg-skeleton height-25 mt-6"
                  style="width: 70%"
                ></div>
              </div>
              <div v-else class="mt-10 word-break">
                <MarkdownView :source="sessionForm.description" />
              </div>
             
                
              <div v-if="mainPreview" class="fc-6C6C6C fs-12">

                  <div v-if="sessionForm.creator == user.name">


                  <div class="flex mt-34">
                    <img
                      v-if="user.pic"
                      v-lazy="user.pic"
                      :alt="user.firstname + user.lastname"
                      :key="user.pic"
                      class="image-skeleton image-profile-16 mr-8"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-16 flex-mid mr-8"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-16 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: user.firstname,
                            lastName: user.lastname,
                          })
                        }}
                      </div>
                    </div>
                    <div class="mt-2">
                      {{ $t("happilyVillage.Led_by") }}
                      <span class="fw-700 fc-404243"
                      :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ user.firstname }} {{ user.lastname.charAt(0) }}</span
                      >
                    </div>
                  </div>

                  </div>


                  <div v-else>
                    <div class="flex mt-34">
                      <img
                      v-lazy="getCreatorPic()"
                      :alt="sessionForm.creator"
                      :key="getCreatorPic()"
                      class="image-skeleton image-profile-16 mr-8"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    
                    <div class="mt-2">
                      {{ $t("happilyVillage.Led_by") }}
                      <span class="fw-700 fc-404243"
                      :class="[ blurMode ?  'blurelement': '' ]"
                        >{{sessionForm.creator}}</span
                      >
                    </div>
                  </div>




                  </div>
                <div v-if="sessionForm.dateAndTime" class="flex-center mt-10">
                  <img
                    :src="$utils('icons', 'ic_twotone_cal')"
                    class="mini-icon mt-1"
                  />
                  <div class="ml-8">{{ sessionForm.dateAndTime }}</div>
                </div>
                <div v-if="sessionForm.duration" class="flex-center mt-10">
                  <img
                    :src="$utils('icons', 'ic_twotone_clock')"
                    class="mini-icon"
                  />
                  <div class="ml-8">{{ getHour(sessionForm.duration) }}</div>
                </div>
                <div v-if="sessionForm.location" class="flex-center mt-10">
                  <img
                    :src="$utils('icons', 'ic_twotone_location')"
                    class="mini-icon"
                  />
                  <div class="ml-8">{{ sessionForm.location.trim() }}</div>
                </div>
                <div v-if="sessionFormSessionLimitNumber > 0" class="mt-30">
                  <div class="fs-14 ml-6 mb-6">
                    {{ $t("happilyVillage.SIGN_UPS") }} ({{
                      $utils("addCommasInNumber", sessionFormSessionLimitNumber)
                    }}
                    {{ $t("happilyVillage.spots_available") }})
                  </div>
                  <div class="flex" style="flex-wrap: wrap">
                    <div v-for="index in sessionFormVisibleSpotCount" :key="index">
                      <div class="mockup-icon"></div>
                    </div>
                    <div
                      v-if="sessionFormHiddenSpotCount > 0"
                      class="mt-10 fc-3D8080"
                    >
                      +
                      {{
                        $utils(
                          "addCommasInNumber",
                          sessionFormHiddenSpotCount
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="flex" style="margin-top: 60px">
                  <div class="bg-skeleton height-cycle"></div>
                  <div class="bg-skeleton height-20"></div>
                </div>
                <div class="flex mt-6">
                  <div class="bg-skeleton height-cycle"></div>
                  <div class="bg-skeleton height-20"></div>
                </div>
                <div class="flex mt-6">
                  <div class="bg-skeleton height-cycle"></div>
                  <div class="bg-skeleton height-20"></div>
                </div>
              </div>
              <div
                v-if="!(sessionFormSessionLimitNumber > 0) && !mainPreview"
                class="bg-skeleton height-25 mt-24"
                style="width: 55%; margin-buttom: 100px"
              ></div>
              <div
                class="relative"
                :class="`${
                  !(sessionFormSessionLimitNumber > 0) && !mainPreview
                    ? 'mt-40 pt-40'
                    : ''
                }`"
              >
                <div class="flex-center price-box my-40">
                  <div class="fc-B7B7B7 mt-2 pr-20">{{ $t("happilyVillage.PRICE") }}</div>
                  <div class="mt-2 coin relative mr-12">&nbsp;</div>
                  <div
                    v-if="sessionForm.price + 1 > 0 && mainPreview"
                    class="fs-18 fw-700 fc-000000 mt-3"
                  >
                    {{ sessionForm.price }}
                  </div>
                  <div v-else class="bg-skeleton height-20" style="width: 20px">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div class="grid-right">
            <div class="hv-dialog-title">{{ sessionModalType === 'edit' ? 'Edit session' : 'New session' }}</div>
            <form id="sessionModal" @submit.prevent="sessionSubmit">

              <div class="title">
                {{ $t("happilyVillage.Session_Type") }}
              </div>
              <el-radio-group v-model="sessionForm.classType" size="small">
                <el-radio-button :label="CLASS_TYPE.LIVE">{{ $t("happilyVillage.Live") }}</el-radio-button>
                <el-radio-button :label="CLASS_TYPE.VIDEO">{{ $t("happilyVillage.Video") }}</el-radio-button>
              </el-radio-group>

              <div class="title">
                {{ $t("happilyVillage.Creator") }}
              </div>
              <div class="relative">
                <el-select
                  v-model="sessionForm.creator"
                  :placeholder="$t('happilyVillage.Select_Creator')"
                  class="creator-profile"
                  :class="[ blurMode ?  'blurelement': '' ]"
                >
                  <el-option
                    v-for="item in creatorList"
                    :key="item.name"
                    :label="item.name"
                    style="height: 42px"
                    :value="item.name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  >
                    <div class="flex-center my-4">
                      <div v-if="item.name != user.name">
                        <img
                          class="image-skeleton image-profile-32 mr-16"
                          :src="item.pic"
                          alt=""
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                      </div>
                      <div v-else>
                        <div v-if="user.pic">
                          <img
                            v-lazy="user.pic"
                            :key="user.pic"
                            class="
                              image-skeleton image-profile-32
                              flex-mid
                              mr-12
                            "
                            :class="[ blurMode ?  'blurelement': '' ]"
                          />
                        </div>
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: user.firstname,
                                lastName: user.lastname,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="fs-18 fc-2D2E36">{{ item.name }}</div>
                    </div>
                  </el-option>
                </el-select>
                <div class="profiel-selected">
                  <div v-if="sessionForm.creator == user.name">
                    <div v-if="user.pic">
                      <img
                        class="image-skeleton image-profile-32"
                        :src="user.pic"
                        alt=""
                        :class="[ blurMode ?  'blurelement': '' ]"
                      />
                    </div>
                    <div v-else class="image image-profile-32 flex-mid mr-12"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-32 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: user.firstname,
                            lastName: user.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="item in creatorList"
                    :key="item.name + '_showing_imge'"
                  >
                    <div
                      v-if="
                        item.name == sessionForm.creator &&
                        sessionForm.creator != user.name
                      "
                    >
                    
                      <img
                        class="image-skeleton image-profile-32"
                        :src="item.pic"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>

              



              <div class="title">
                {{ $t("happilyVillage.Share_with") }}
              </div>
              <!-- <el-tooltip
                class="header-table-tooltip"
                placement="top"
                effect="light"
              >
                <div slot="content">
                  {{ $t("happilyVillage.Huddle_selection_is") }}
                  <br />{{ $t("happilyVillage.Coming_soon_to_the") }}
                </div> -->
              <el-cascader
                class="defaulttags"
                v-model="huddleTag"
                :placeholder="$t('happilyVillage.Team_or_Name')"
                :options="huddleTagData"
                :props="{ multiple: true }"
                style="width: 100%"
                filterable
                :filter-method="filterToFunction"
                :class="[ blurMode ?  'blurelement': '' ]"
              ></el-cascader>
              <!-- </el-tooltip> -->
              <div v-if="isProgramOnlySelected" class="program-only-hint">
                <span class="program-only-hint-icon"><i class="el-icon-lock"/></span>
                <div class="program-only-hint-copy">
                  <div class="program-only-hint-title">Program only</div>
                  <div class="program-only-hint-sub">
                    Hidden from University. Surfaces only to people enrolled in a Learning Program that uses this session. Visibility scope, not encryption.
                  </div>
                </div>
              </div>
              <div class="title">
                {{ $t("happilyVillage.Name_of_Session") }}
              </div>
              <el-input
                :placeholder="$t('happilyVillage.Short_but_descriptive_eg')"
                v-model="sessionForm.name"
                class="name"
                :class="{ 'validate-input': validateSessionForm.name }"
              ></el-input>
              <div v-if="validateSessionForm.name" class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Name") }}
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Description") }}</div>
              <MarkdownEditor
                v-model="sessionForm.description"
                :placeholder="$t('happilyVillage.A_sentence_or_two_about')"
                :has-error="validateSessionForm.description"
                :autosize="{ minRows: 4, maxRows: 8 }"
              />
              <div
                v-if="validateSessionForm.description"
                class="validate-worming"
              >
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Description") }}
                </div>
              </div>
              <template v-if="sessionForm.classType === CLASS_TYPE.LIVE">
              <div class="grid-2-auto">
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Date_and_Time") }}
                  </div>
                  <el-date-picker
                    v-model="sessionForm.dateAndTime"
                    type="datetime"
                    format="MMMM d yyyy h:mm A"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    default-time="09:00:00"
                    :picker-options="sessionDatePickerOptions"
                    :class="{
                      'validate-input': validateSessionForm.dateAndTime,
                    }"
                    :placeholder="$t('happilyVillage.When')"
                  ></el-date-picker>
                  <div
                    v-if="validateSessionForm.dateAndTime"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Date") }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Duration_minutes") }}
                  </div>
                  <el-input
                    type="number"
                    :placeholder="$t('happilyVillage.How_long')"
                    v-model="sessionForm.duration"
                    :class="{ 'validate-input': validateSessionForm.duration }"
                  ></el-input>
                  <div
                    v-if="validateSessionForm.duration"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Location") }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid-2-auto">
                <div>
                  <div class="title">{{ $t("happilyVillage.Location") }}</div>
                    <el-input
                      :placeholder="$t('happilyVillage.Where')"
                      v-model="sessionForm.location"
                      :class="{ 'validate-input': validateSessionForm.location }"
                    ></el-input>
                    <div v-if="validateSessionForm.location" class="validate-worming">
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Location") }}
                    </div>
                  </div>
                </div>


                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Price_coins") }}
                  </div>
                  <el-input
                    type="number"
                    :placeholder="$t('happilyVillage.How_much')"
                    v-model="sessionForm.price"
                    :min="0"
                    :disabled="this.editSessionsStatus"
                    :class="{ 'validate-input': validateSessionForm.price }"
                  ></el-input>
                  <div
                    v-if="validateSessionForm.price"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_rice") }}
                    </div>
                  </div>
                </div>


              </div>
              </template>

              <template v-if="sessionForm.classType === CLASS_TYPE.VIDEO">
              <div class="title">Video source</div>
              <el-radio-group v-model="sessionForm.videoSource" size="small">
                <el-radio-button :label="VIDEO_SOURCE.YOUTUBE">YouTube</el-radio-button>
                <el-radio-button :label="VIDEO_SOURCE.UPLOAD">Upload MP4</el-radio-button>
              </el-radio-group>

              <div v-if="sessionForm.videoSource === VIDEO_SOURCE.YOUTUBE">
                <div class="title">YouTube URL</div>
                <el-input
                  v-model="sessionForm.videoUrl"
                  placeholder="https://www.youtube.com/watch?v=..."
                  :class="{ 'validate-input': validateSessionForm.videoUrl }"
                ></el-input>
                <div v-if="validateSessionForm.videoUrl" class="validate-worming">
                  <div class="text">Enter a valid YouTube URL.</div>
                </div>
              </div>

              <div v-if="sessionForm.videoSource === VIDEO_SOURCE.UPLOAD">
                <div class="title">Video file</div>
                <el-upload
                  ref="videoUpload"
                  action="#"
                  :auto-upload="false"
                  :limit="1"
                  :on-change="handleVideoChange"
                  :on-remove="handleVideoRemove"
                  :file-list="sessionForm.videoFileList"
                  accept="video/mp4,video/*"
                >
                  <el-button>Choose video</el-button>
                  <div slot="tip" class="el-upload__tip">
                    MP4 recommended; large files take a moment to upload on save.
                  </div>
                </el-upload>
                <div v-if="validateSessionForm.videoFile" class="validate-worming">
                  <div class="text">Choose a video file.</div>
                </div>
              </div>

              <div v-if="canSetXP" class="title">XP reward</div>
              <div v-if="canSetXP" class="xp-picker">
                <el-button
                  v-for="preset in VIDEO_XP_PRESETS"
                  :key="preset"
                  :type="sessionForm.xpAmount === preset ? 'primary' : 'default'"
                  size="small"
                  @click="sessionForm.xpAmount = preset"
                >{{ preset }} XP</el-button>
                <el-input-number
                  v-model="sessionForm.xpAmount"
                  :min="1"
                  :step="5"
                  size="small"
                  style="width: 110px;"
                ></el-input-number>
              </div>
              </template>


              




              <div class="grid-2-auto">



                <div v-if="sessionForm.classType === CLASS_TYPE.LIVE">
                  <div class="title">
                    {{ $t("happilyVillage.Session_Minimum") }}
                  </div>
                  <el-input
                    type="number"
                    :placeholder="$t('happilyVillage.Session_Minimum')"
                    v-model="sessionForm.sessionMinimum"
                    :class="{
                      'validate-input': validateSessionForm.sessionMinimum,
                    }"
                  ></el-input>
                  <div
                    v-if="validateSessionForm.sessionMinimum"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Session_Minimum") }}
                    </div>
                  </div>
                </div>


                <div v-if="sessionForm.classType === CLASS_TYPE.LIVE">
                  <div class="title">
                    {{ $t("happilyVillage.Session_Maximum") }}
                  </div>
                  <el-input
                    type="number"
                    :placeholder="$t('happilyVillage.Session_Maximum')"
                    v-model="sessionForm.sessionLimit"
                    :class="{
                      'validate-input': validateSessionForm.sessionLimit,
                    }"
                  ></el-input>
                  <div
                    v-if="validateSessionForm.sessionLimit"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Session_Limit") }}
                    </div>
                  </div>
                </div>






                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Add_to_Topic") }}
                  </div>
                  <el-select
                    v-model="sessionForm.topic"
                    :placeholder="$t('happilyVillage.Select')"
                  >
                    <el-option
                      v-for="item in topicOpt"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </div>
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Comment_Permissions") }}
                  </div>
                  <el-select
                    v-model="sessionForm.commentPermission"
                    :placeholder="$t('happilyVillage.Select')"
                  >
                    <el-option
                      v-for="item in commentPerm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="hv-dialog-footer">
                <el-button @click="sessionModalStatus = false">{{ $t("global.Cancel") }}</el-button>
                <el-button
                  v-if="editSessionsStatus"
                  type="primary"
                  @click.prevent="saveSession"
                  >{{ $t("happilyVillage.Save_Changes") }}</el-button
                >
                <el-button
                  v-else
                  type="primary"
                  @click.prevent="sessionSubmit"
                  >{{ $t("happilyVillage.CREATE_SESSION") }}</el-button
                >
                <!-- <el-button
                  class="btn-cancel bigger"
                  @click="saveDraftSessionForm"
                >SAVE AS DRAFT</el-button>-->
              </div>
            </form>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="modal-sign-ups">
      <el-dialog :visible.sync="dialogSignUps" top="8vh">
        <div class="recipients-modal">
          <div>
            <span
              class="fs-20 fw-700 fc-000000 mr-40 word-break"
              :style="$utils('fontStyle', modalSignUps.class_name)"
              >{{ modalSignUps.class_name }}</span
            >
          </div>
          <div class="mt-4 fc-626262">
            {{ $t("happilyVillage.Created_by") }} {{ modalSignUps.create_name }}
          </div>
          <div class="mt-24 fs-18 fc-000000">
            <span class="fw-700">{{
              $utils("addCommasInNumber", modalSignUps.signup)
            }}</span>
            <span>&nbsp;{{ $t("happilyVillage.sign_ups_of") }}&nbsp;</span>
            <span class="fw-700">{{
              $utils("addCommasInNumber", modalSignUps.class_limit)
            }}</span>
            <span>&nbsp;{{ $t("happilyVillage.available_spots") }}</span>
          </div>
        </div>
        <div class="members-recipients thin-scrollbar">
          <div
            v-for="item in modalSignUps.student"
            :key="item.email"
            class="rowDataStyle"
            :class="[ blurMode ?  'blurelement': '' ]"
          >
            <div class="columnDataStyle" style="width: 100%">
              <div class="flex-center py-7">
                <div v-if="item.image">
                  <img
                    v-lazy="item.image"
                    :key="item.image"
                    class="image-skeleton image-profile-42 flex-mid mr-16"
                  />
                </div>
                <div v-else class="image image-profile-42 flex-mid mr-12">
                  <div
                    class="flex-mid text-in-image text-in-image-42"
                    style="width: 42px"
                  >
                    {{
                      $utils("acronymName", {
                        firstName: item.firstname,
                        lastName: item.lastname,
                      })
                    }}
                  </div>
                </div>
                <div class="flex-column pl-4">
                  <span class="text-name"
                    >{{ item.firstname }} {{ item.lastname }}</span
                  >
                  <span class="text-email">{{ item.email }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="modalSignUps.student.length == 0" class="flex-mid">
            <div class="fs-22 opa-04 p-40 mt-40 mb-30">
              {{ $t("happilyVillage.No_one_sign_up") }}
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="comments-modal">
      <el-dialog
        :visible.sync="commentModal"
        width="930px"
        @close="closeCommentModal"
      >
        <div class="grid-2-sesstion grid-2-detail">
          <div class="grid-left-no relative thin-scrollbar p-40" style="height: 600px">
            <div class="fc-404243 fs-18 fw-900 word-break">
              {{ commentDetail.title }}
            </div>
            <div
              class="fc-767676 fw-400 fs-14 mt-10 word-break"
              style="min-height: 40px"
            >
              <MarkdownView v-if="isMarkdown(commentDetail, 'class_description')" :source="commentDetail.class_description_md" />
              <div v-else class="pre-line">{{ commentDetail.description }}</div>
            </div>
            <div class="flex mt-34">
              <img
                v-if="commentDetail.creatorImageProfile"
                v-lazy="commentDetail.creatorImageProfile"
                class="image-skeleton image-profile-16 mr-6"
                :src="commentDetail.creatorImageProfile"
                alt=""
                :class="[ blurMode ?  'blurelement': '' ]"
              />
              <div v-else class="image image-profile-16 flex-mid mr-8"
              :class="[ blurMode ?  'blurelement': '' ]">
                <div class="text-in-image text-in-image-16 flex-mid">
                  {{
                    $utils("acronymName", {
                      firstName: user.firstname,
                      lastName: user.lastname,
                    })
                  }}
                </div>
              </div>
              <div class="mt-2">
                {{ $t("happilyVillage.Led_by") }}
                <span class="fw-700 fc-404243"
                :class="[ blurMode ?  'blurelement': '' ]"
                  >{{ commentDetail.firstname }}
                  {{ commentDetail.lastname.charAt(0) }}</span
                >
              </div>
            </div>
            <div v-if="commentDetail.dateAndTime" class="flex-center mt-10">
              <img
                :src="$utils('icons', 'ic_twotone_cal')"
                class="mini-icon mt-1"
              />
              <div class="ml-8">{{ commentDetail.dateAndTime }}</div>
            </div>
            <div v-if="commentDetail.duration" class="flex-center mt-10">
              <img
                :src="$utils('icons', 'ic_twotone_clock')"
                class="mini-icon"
              />
              <div class="ml-8">{{ getHour(commentDetail.duration) }}</div>
            </div>
            <div v-if="commentDetail.location" class="flex-center mt-10">
              <img
                :src="$utils('icons', 'ic_twotone_location')"
                class="mini-icon"
              />
              <div class="ml-8">{{ commentDetail.location.trim() }}</div>
            </div>
            <div v-if="commentDetailSessionLimitNumber > 0" class="mt-30">
              <div class="fs-14 ml-6 mb-6">
                {{ $t("happilyVillage.SIGN_UPS") }} ({{
                  $utils("addCommasInNumber", commentDetailStudentCount)
                }}/{{
                  $utils("addCommasInNumber", commentDetailSessionLimitNumber)
                }}<span>&nbsp;{{ $t("happilyVillage.available_spots") }}</span>)
              </div>
              <div class="flex" style="flex-wrap: wrap">
                <div v-for="value in commentDetail.student" :key="value.id">
                  <img
                    v-if="value.imageProfile"
                    v-lazy="value.imageProfile"
                    class="image-skeleton image-profile-24 mt-6 mr-6"
                    :src="value.imageProfile"
                    alt=""
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                  <div v-else class="image image-profile-24 flex-mid mt-6 mr-8"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="text-in-image text-in-image-24 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: value.firstname,
                          lastName: value.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
                <div v-for="index in commentDetailVisibleSpotCount" :key="index">
                  <div class="mockup-icon"></div>
                </div>
                <div
                  v-if="commentDetailHiddenSpotCount > 0"
                  class="mt-10 fc-3D8080"
                >
                  +
                  {{
                    $utils(
                      "addCommasInNumber",
                      commentDetailHiddenSpotCount
                    )
                  }}
                </div>
              </div>
            </div>



            <div class="relative pb-40 pt-40">
              <div class="flex-center price-box">
                <div class="fc-B7B7B7 mt-2 pr-20">{{ $t("happilyVillage.PRICE") }}</div>
                <div class="mt-2 coin relative mr-12">&nbsp;</div>
                <div
                  v-if="commentDetail.price + 1 > 0"
                  class="fs-18 fw-700 fc-000000 mt-3"
                >
                  {{ commentDetail.price }}
                </div>
                <div v-else class="bg-skeleton height-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
            </div>



          </div>
          <div class="grid-right comment-contrainer">
            <div class="fc-404243 fw-900 fs-17">
              {{ $utils("addCommasInNumber", commentDetail.commentsall) }}
              {{ commentDetail.commentsall == 1?  $t("happilyVillage.comment") : $t("happilyVillage.comments") }}
            </div>
            <div class="comment-card mt-12">
              <div class="comment-box thin-scrollbar">
                <div v-if="commentData.length == 0" class="no-comment opa-05">
                  {{ $t("happilyVillage.Be_the_first_to_comment") }}
                </div>
                <div v-else class="">
                  <div
                    v-for="(value, valueI) in commentData"
                    :key="value.mparent_id + value.likeorder + valueI"
                  >
                    <div class="comment flex">
                      <div class="content-comment">
                        <img
                          v-if="value.creatorImageProfile"
                          v-lazy="value.creatorImageProfile"
                          class="image-skeleton image-profile-32 mr-12"
                          :src="value.creatorImageProfile"
                          alt=""
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                fullName: value.name,
                              })
                            }}
                          </div>
                        </div>
                        <div class="flex-center">
                          <div class="">
                            <div class="fs-13">
                              <span class="fw-700 fc-AFAFAF"
                              :class="[ blurMode ?  'blurelement': '' ]"
                                >{{ value.name }}&nbsp;</span
                              >
                              <span
                                class="fc-464646 word-break"
                                v-html="urlify(value.value)"
                              ></span>
                            </div>

                            <div v-if="value.image">
                              <img
                                v-lazy="value.image"
                                :alt="value.name"
                                class="img-preview image-skeleton"
                              />
                            </div>
                            <div class="fs-11 fc-AFAFAF flex-center">
                              <div
                                @click="replyComment(value)"
                                class="cursor-pointer"
                                style="color: #70dbcb"
                              >
                                {{ $t("happilyVillage.Reply") }}
                              </div>
                              <div>
                                &nbsp;• {{ value.like }} {{ $t("happilyVillage.Likes") }}&nbsp;•
                               {{ prettyDate(value.createdate) }}
                              </div>
                              <div
                                class="flex-center"
                                v-if="value.giftcoin > 0"
                              >
                                &nbsp;•
                                <img
                                  :src="$utils('icons', 'coins-12px')"
                                  alt="icons_coins-12px"
                                  class="mx-4 mb-2"
                                />
                                × {{ value.giftcoin }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex-mid">
                        <img
                          v-if="value.liked === false"
                          @click.prevent="likeOrUnlike(value)"
                          :src="$utils('icons', 'btn_like_off_32px')"
                          alt="icons_btn_like_off_32px"
                          class="cursor-pointer"
                        />
                        <img
                          v-else
                          @click.prevent="likeOrUnlike(value)"
                          :src="$utils('icons', 'btn_like_on_32px')"
                          alt="icons_btn_like_on_32px"
                          class="cursor-pointer"
                        />
                      </div>
                    </div>
                    <div
                      v-for="(subValue, index) in value.subComment"
                      :key="
                        value.mparent_id +
                        subValue.likeorder +
                        valueI +
                        value.likeorder +
                        index
                      "
                      class="comment flex"
                    >
                      <div class="content-comment-sub">
                        <img
                          :src="$utils('icons', 'ic_reply_arrow_24px')"
                          alt="icons_ic_reply_arrow_24px"
                        />
                        <img
                          v-if="subValue.creatorImageProfile"
                          v-lazy="subValue.creatorImageProfile"
                          class="image-skeleton image-profile-32 mr-12"
                          :src="subValue.creatorImageProfile"
                          alt=""
                        />
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                fullName: subValue.name,
                              })
                            }}
                          </div>
                        </div>
                        <div class="flex-center">
                          <div class="">
                            <div class="fs-13">
                              <span class="fw-700 fc-AFAFAF"
                                >{{ subValue.name }}&nbsp;</span
                              >
                              <span
                                class="fc-464646 word-break"
                                v-html="urlify(subValue.value)"
                              ></span>
                            </div>
                            <div v-if="subValue.image">
                              <img
                                v-lazy="subValue.image"
                                :alt="subValue.name"
                                class="img-preview image-skeleton"
                              />
                            </div>
                            <div class="fs-11 fc-AFAFAF flex-center">
                              <div
                                @click="replyComment(subValue)"
                                class="cursor-pointer"
                                style="color: #70dbcb"
                              >
                                {{ $t("happilyVillage.Reply") }}
                              </div>
                              <div>
                                &nbsp;• {{ subValue.like }} {{ $t("happilyVillage.Likes") }}&nbsp;•
                               {{ prettyDate(subValue.createdate) }}
                              </div>
                              <div
                                class="flex-center"
                                v-if="subValue.giftcoin > 0"
                              >
                                &nbsp;•
                                <img
                                  :src="$utils('icons', 'coins-12px')"
                                  alt="icons_coins-12px"
                                  class="mx-4 mb-2"
                                />
                                × {{ subValue.giftcoin > 0 }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex-mid">
                        <img
                          v-if="subValue.liked == false"
                          @click.prevent="replylikeOrUnlike(subValue)"
                          :src="$utils('icons', 'btn_like_off_32px')"
                          alt="icons_btn_like_off_32px"
                          class="cursor-pointer"
                        />
                        <img
                          v-else
                          @click.prevent="replylikeOrUnlike(subValue)"
                          :src="$utils('icons', 'btn_like_on_32px')"
                          alt="icons_btn_like_on_32px"
                          class="cursor-pointer"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div id="comment_data_bottom_university"></div>
              </div>
              <div class="input-container flex-center">
                <img
                  v-if="userLogin.profilepic"
                  v-lazy="userLogin.profilepic"
                  class="image-skeleton image-profile-32 mr-12"
                  :src="userLogin.profilepic"
                  alt=""
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
                <div v-else class="image image-profile-32 flex-mid mr-12"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-32 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: userLogin.firstname,
                        lastName: userLogin.lastname,
                      })
                    }}
                  </div>
                </div>
                <div
                  class="relative input-contain"
                  style="display: grid; grid-template-columns: auto 1fr"
                >
                  <div class="flex-center">
                    <div
                      v-if="replyCommentData.name"
                      class="reply-tag ml-6 flex-center"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <img
                        :src="$utils('icons', 'ic_reply_arrow_small_16px')"
                        alt="icons_ic_reply_arrow_small_16px"
                      />
                      {{ replyCommentData.name }}
                    </div>
                  </div>
                  <input
                    v-model="messageInput"
                    @keyup="searchMember(messageInput)"
                    class="input-box"
                    type="text"
                    :placeholder="
                      replyCommentData.name
                        ? $t('happilyVillage.Reply_here')
                        : $t('happilyVillage.Comment_here')
                    "
                  />
                  <div
                    class="mention-container thin-scrollbar"
                    :style="mentionsTopPosition(this.searchMemberArr.length)"
                    v-if="this.searchMemberArr.length > 0"
                  >
                    <div
                      class="memeber-box flex-center"
                      @click="mentionToText(mem)"
                      v-for="mem in this.searchMemberArr"
                      :key="mem.id + '_searching'"
                    >
                      <div>
                        <div>{{ mem.fullname }}</div>
                        <div class="opa-08 fs-10">{{ mem.email }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  v-if="replyCommentData.user && messageInput"
                  @click="submitReply"
                  src="@/assets/images/happilyvillage/btn-send.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
                <img
                  v-else-if="replyCommentData.user"
                  @click="clearReplyData"
                  src="@/assets/images/happilyvillage/btn-reply-cancel.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
                <img
                  v-else
                  @click="submitMessage"
                  src="@/assets/images/happilyvillage/btn-send.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { buildHVBarOptions, buildHVBarDataset } from "./helpers/chart-defaults.js";
import { min } from "date-fns";
import format from "date-fns/format";
import team from "@/store/team";
import moment from "moment";
import { enforceProgramOnlyExclusivity, PROGRAM_ONLY_KEY } from "../../store/huddle-helpers";
import {
  CLASS_TYPE,
  VIDEO_SOURCE,
  VIDEO_XP_REWARD,
  VIDEO_XP_PRESETS,
  parseYouTubeVideoId,
  isValidYouTubeUrl,
  canSetVideoXP,
  captureVideoThumbnail,
} from "./video-class-helpers";
import MarkdownEditor from "../markdown/editor/MarkdownEditor.vue";
import MarkdownView from "../markdown/MarkdownView.vue";
import { isMarkdown, initialEditorValue, stripMarkdown } from "../markdown";

export default {
  name: "university",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
    universityCampaigns: require("./university-campaigns").default,
    MarkdownEditor,
    MarkdownView,
  },
  created() {
    this.$store.dispatch(
      "happilyvillageUniversity/getHouseAndTeam",
      this.userLogin
    );
    this.$store.dispatch("happilyvillageUniversity/getUser", this.userLogin);
    this.$store.dispatch("happilyvillageTownhall/getCreator", this.userLogin);
  },
  watch: {
    university_graphmonth() {
      if (this.university_bar_chart) {
        this.university_bar_chart.destroy();
      }
      this.randerBarChartUniversity();
    },
    inputSearchSession() {
      if (!this.inputSearchSession) {
        this.typeingSearchSession();
      }
    },
    huddleTag(newVal) {
      // Live UI feedback for the rule that buildHuddleSave enforces on
      // save: Program only and other huddle picks are mutually exclusive.
      const next = enforceProgramOnlyExclusivity(newVal);
      if (next) this.huddleTag = next;
    },
  },
  computed: {
    userLogin() {
      return this.$store.getters["authen/user"];
    },
    allusers() {
      return this.$store.getters["happilyvillage/allusers"];
    },
    sessions() {
      return this.$store.getters["happilyvillageUniversity/sessions"];
    },
    topicOpt() {
      return this.$store.getters["happilyvillageUniversity/topicOpt"];
    },
    universityall() {
      return this.$store.getters["happilyvillageUniversity/universityall"];
    },
    university_graphmonth() {
      return this.$store.getters[
        "happilyvillageUniversity/university_graphmonth16"
      ];
    },
    university_total() {
      return this.$store.getters["happilyvillageUniversity/university_total16"];
    },
    inputSearchSession: {
      get() {
        return this.$store.getters[
          "happilyvillageUniversity/inputSearchSessions"
        ];
      },
      set(value) {
        this.$store.commit("happilyvillageUniversity/setInputSearchSessions", {
          keyword: value,
        });
      },
    
    },
    creatorList() {
      // console.log('creatorList',this.$store.getters["happilyvillageTownhall/creator"])
      return this.$store.getters["happilyvillageTownhall/creator"];
    },
    sessionResults() {
      return this.$store.getters["happilyvillageUniversity/sessionResults"];
    },
    loadingUniversitySessionsTable() {
      return this.$store.getters[
        "happilyvillageUniversity/loadingUniversitySessionsTable"
      ];
    },
    mainPreview() {
      return !!(
        this.$utils("watchingTrim", this.sessionForm.name) &&
        this.sessionDescriptionStripped
      );
    },
    sessionDescriptionStripped() {
      return stripMarkdown(this.sessionForm.description || "").trim();
    },
    huddleTagData() {
      return this.$store.getters["happilyvillageUniversity/huddleTagData"];
    },
    commentData() {
      this.scrollToBottomComments();
      return this.$store.getters["happilyvillageUniversity/comment"];
    },
    userAll(){
       return this.$store.getters["happilyvillageUniversity/userAll"];
    },
    commentId() {
      return this.$store.getters["happilyvillageUniversity/commentId"];
    },
    member() {
      return this.$store.getters["happilyvillageUniversity/member"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    isProgramOnlySelected() {
      return (this.huddleTag || []).some((tag) => {
        const k = Array.isArray(tag) ? tag[0] : tag;
        return k === PROGRAM_ONLY_KEY;
      });
    },
    canSetXP() {
      // Mirrors RN: only privileged roles can override the default
      // 25 XP reward on a video session.
      return canSetVideoXP(this.userLogin);
    },
    sessionFormSessionLimitNumber() {
      const sessionLimit = parseInt(this.sessionForm.sessionLimit, 10);
      return Number.isFinite(sessionLimit) && sessionLimit > 0
        ? sessionLimit
        : 0;
    },
    sessionFormVisibleSpotCount() {
      return Math.min(this.sessionFormSessionLimitNumber, 108);
    },
    sessionFormHiddenSpotCount() {
      return Math.max(
        this.sessionFormSessionLimitNumber - this.sessionFormVisibleSpotCount,
        0
      );
    },
    commentDetailStudentCount() {
      return Array.isArray(this.commentDetail.student)
        ? this.commentDetail.student.length
        : 0;
    },
    commentDetailSessionLimitNumber() {
      const sessionLimit = parseInt(this.commentDetail.sessionLimit, 10);
      return Number.isFinite(sessionLimit) && sessionLimit > 0
        ? sessionLimit
        : 0;
    },
    commentDetailVisibleSpotCount() {
      return Math.min(
        Math.max(
          this.commentDetailSessionLimitNumber - this.commentDetailStudentCount,
          0
        ),
        108
      );
    },
    commentDetailHiddenSpotCount() {
      return Math.max(
        this.commentDetailSessionLimitNumber -
          this.commentDetailStudentCount -
          this.commentDetailVisibleSpotCount,
        0
      );
    },
  },
  data() {
    return {
      // Video-class constants exposed to the template. Frozen at module
      // scope so binding them directly is safe.
      CLASS_TYPE,
      VIDEO_SOURCE,
      VIDEO_XP_PRESETS,
      activeSubTab: "sessions",
      id: "",
      universitySessions: [],
      loadingChartStatus: true,
      sessionModalStatus: false,
      sessionModalType: "create",
      commentModal: false,
      downloadSessionsBar: false,
      onlineCourses: [],
      loadingOnlineCoursesTable: false,
      inputSearchCourse: null,
      addCoursesModal: false,
      downloadCoursesBar: false,
      dialogSignUps: false,
      editSessionsStatus: false,
      modalSignUps: {
        class_name: "",
        create_name: "",
        signup: 0,
        class_limit: 0,
        student: [],
      },
      user: {
        pic: null,
        firstname: "Firstname",
        lastname: "Lastname",
        name: "Firstname L",
      },
      sessionDatePickerOptions: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Today, 9:00 AM",
            onClick(picker) {
              const d = new Date();
              d.setHours(9, 0, 0, 0);
              picker.$emit("pick", d);
            },
          },
          {
            text: "Tomorrow, 9:00 AM",
            onClick(picker) {
              const d = new Date();
              d.setDate(d.getDate() + 1);
              d.setHours(9, 0, 0, 0);
              picker.$emit("pick", d);
            },
          },
          {
            text: "Next Monday, 9:00 AM",
            onClick(picker) {
              const d = new Date();
              const daysUntilMonday = (1 - d.getDay() + 7) % 7 || 7;
              d.setDate(d.getDate() + daysUntilMonday);
              d.setHours(9, 0, 0, 0);
              picker.$emit("pick", d);
            },
          },
          {
            text: "In 1 hour",
            onClick(picker) {
              const d = new Date();
              d.setMinutes(0, 0, 0);
              d.setHours(d.getHours() + 1);
              picker.$emit("pick", d);
            },
          },
        ],
      },
      sessionForm: {
        creator:null,
        name: "",
        description: "",
        dateAndTime: "",
        duration: null,
        location: "",
        sessionLimit: null,
        price: null,
        topic: null,
        commentPermission: 1,
        sessionMinimum: null,
        // Video-class fields. classType=='live' keeps the existing
        // live-class behaviour; 'video' switches the form into the
        // YouTube/Upload variant and zeros the live-only fields on save.
        classType: 'live',
        videoSource: 'youtube',
        videoUrl: '',
        videoFile: null,
        videoFileList: [],
        videoThumbnail: null,
        xpAmount: VIDEO_XP_REWARD,
      },
      validateSessionForm: {
        name: false,
        description: false,
        dateAndTime: false,
        duration: false,
        location: false,
        sessionLimit: false,
        price: false,
        topic: false,
        sessionMinimum: false,
        videoUrl: false,
        videoFile: false,
      },
      commentPerm: [
        { value: 1, label: "Anyone can comment" },
        { value: 2, label: "Only signees can comment" },
        { value: 3, label: "Only me" },
      ],
      huddleTag: [["everyone"]],
      commentDetail: {
        title: "Today’s Magic Word: +200 coins Giveaway!",
        description: "",
        class_description: "",
        class_description_md: "",
        class_description_format: "",
        creator: "Tony S",
        firstname: "Tony",
        lastname: "Stark",
        creatorImageProfile: "",
        dateAndTime: "2022-07-15 03:00:00",
        duration: 60,
        location: "Siam center",
        sessionLimit: 30,
        student: [
          {
            id: "fasdfjlsdaf",
            firstname: "Tony",
            lastname: "Stark",
            imageProfile: "",
          },
        ],
        price: 3,
      },
      messageInput: "",
      searchMemberArr: [],
      // member: [
      //   {
      //     name: "AA",
      //     firstname: "Ali",
      //     fullname: "Ali Alies",
      //     email: "ali_a@email.com",
      //     id: "ali1B111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Beatriz",
      //     fullname: "Beatriz Beatroze",
      //     email: "beatriz_b@email.com",
      //     id: "beatriz1N111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Ceatriz",
      //     fullname: "Ceatriz Mit",
      //     email: "ceatriz_m@email.com",
      //     id: "beatrizM1111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Meatriz",
      //     fullname: "Meatriz Hrolla",
      //     email: "meatriz_h@email.com",
      //     id: "beatriz1111",
      //   },
      //   {
      //     name: "CT",
      //     firstname: "Charles",
      //     fullname: "Charles Prello",
      //     email: "charles_p@email.com",
      //     id: "charles1111",
      //   },
      //   {
      //     name: "DM",
      //     firstname: "Diya",
      //     fullname: "Diya Mania",
      //     email: "diya_m@email.com",
      //     id: "diya1111",
      //   },
      //   {
      //     name: "EP",
      //     firstname: "Eric",
      //     fullname: "Eric Poomchai",
      //     email: "eric_p@email.com",
      //     id: "aeric1111",
      //   },
      //   {
      //     name: "TG",
      //     firstname: "Tarin",
      //     fullname: "Tarin Gurin",
      //     email: "tarin@email.com",
      //     id: "aeric111tad231",
      //   },
      // ],
      replyCommentData: {
        company: "",
        createdate: "",
        likeorder: 0,
        mparent_id: "",
        name: "",
        type: "",
        user: "",
        value: "",
      },
      sessionId:'',
      mention: [],
      statusUpdate: false,
      currentPage: 1,
      // huddleTagData: [
      //   {
      //     value: "everyone",
      //     label: "Everyone",
      //   },
      // ],
    };
  },
  mounted() {
    if (this.university_bar_chart) {
      this.university_bar_chart.destroy();
    }
    this.randerBarChartUniversity();
    this.openProgramSessionComposerFromRoute();
  },
  methods: {
    isMarkdown,
    getCreatorPic() {
      if (this.sessionForm.creator && this.creatorList) {
        const creator = this.creatorList.find(item => item.name === this.sessionForm.creator);
        return creator ? creator.characterpath : this.user.pic;
      }
      return this.user.pic;
    },
    getHour(duration) {
      if (duration) {
        let min = duration || 0;
        let hour = Math.floor(min / 60);
        if (1 <= hour) {
          min = min - hour * 60;
          if (min) {
            return `${hour} hr ${min} min`;
          } else {
            return `${hour} hr`;
          }
        } else {
          return `${min} min`;
        }
      }
      return "";
    },
    mentionsTopPosition(value) {
      // 140
      let style = "-46px";
      if (value > 3) {
        style = "-146px";
      } else if (value == 3) {
        style = "-126px";
      } else if (value == 2) {
        style = "-86px";
      }
      return "top: " + style;
    },
    async scrollToBottomComments() {
      for (let i = 0; i < 6; i++) {
        await this.$utils("waitingTime", 400);
        this.scrollIntoView();
      }
    },
    scrollIntoView() {
      const element = document.getElementById("comment_data_bottom_university");
      if (element) {
        element.scrollIntoView();
      }
    },
    closeCommentModal() {
      this.commentModal = false;
      if (this.statusUpdate == true) {
        this.$store.commit("happilyvillageUniversity/setSession", []);
        this.$store.commit(
          "happilyvillageUniversity/setLoadingSessionsTable",
          true
        );
        this.$store.dispatch("happilyvillageUniversity/getUniversity").then(() => {
        this.$store.dispatch(
            "happilyvillageUniversity/currentSessionsChange",
            this.currentPage
          );
        });
      }
    },
    likeOrUnlike(value) {
      this.$store.dispatch("happilyvillageUniversity/likeOrUnLike", {
        form: value,
      });
      let commentData = _.find(this.commentData, function (o) {
        return o.key === value.key;
      });
      if (commentData.liked == true) {
        commentData.liked = false;
      } else {
        commentData.liked = true;
      }
    },
    replylikeOrUnlike(value) {
      this.$store.dispatch("happilyvillageUniversity/replylikeOrUnlike", {
        form: value,
      });
      let commentData = _.find(this.commentData, function (o) {
        return o.key === value.maprent_id2;
      });
      let subCommentData = _.find(commentData.subComment, function (o) {
        return o.key === value.key;
      });
      if (subCommentData.liked == true) {
        subCommentData.liked = false;
      } else {
        subCommentData.liked = true;
      }
    },
    replyComment(value) {
      if (value.maprent_id2) {
        let commentData = _.find(this.commentData, function (o) {
          return o.key === value.maprent_id2;
        });
        this.replyCommentData = JSON.parse(JSON.stringify(commentData));
      } else {
        this.replyCommentData = JSON.parse(JSON.stringify(value));
      }
      
    },
    clearReplyData() {
      this.replyCommentData.company = "";
      this.replyCommentData.createdate = "";
      this.replyCommentData.likeorder = 0;
      this.replyCommentData.mparent_id = "";
      this.replyCommentData.name = "";
      this.replyCommentData.type = "";
      this.replyCommentData.user = "";
      this.replyCommentData.value = "";
    },
    searchMember(str) {
      const regex = /\B@[a-z0-9_-]+/gi;
      const members = str.match(regex);
      if (members && members.length > 0) {
        const filterStr = this.checkUserAdded(str);
        const membersFilter = filterStr.match(regex);
        if (
          membersFilter &&
          membersFilter.length > 0 &&
          filterStr.search(membersFilter + " ") < 0
        ) {
          const searchName = membersFilter[membersFilter.length - 1];
          let filtered = _.filter(this.member, (item) => {
            return (
              item.fullname
                .toLowerCase()
                .indexOf(searchName.toLowerCase().slice(1, searchName.length)) >
              -1
            );
          });
          if (filtered.length < this.member.length) {
            this.searchMemberArr = filtered;
          } else {
            this.searchMemberArr = [];
          }
        } else {
          this.searchMemberArr = [];
        }
      } else {
        this.searchMemberArr = [];
      }
    },
    urlify(text) {
      let urlRegex =
        /(\b(https?|http?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, (url) => {
        return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + "</a>";
      });
    },
    checkUserAdded(str) {
      let text = str;
      const regex = /\B@[a-z0-9_-]+/gi;
      const members = str.match(regex);
      for (let i = 0; i < this.mention.length; i++) {
        text = text.replace("@" + this.mention[i].firstname, "");
      }
      let mention = [];
      members.map((v) => {
        let _findmention = _.find(this.mention, function (value) {
          return value.mention  === v;
        });
        if (_findmention) {
          mention.push(_findmention);
        }
      });
      this.mention = mention;
      return text;
    },
    mentionToText(value) {
      const str = this.messageInput;
      const regex = /\B@[a-z0-9_-]+/gi;
      const members = str.match(regex);
      if (members && members.length > 0) {
        const filterStr = this.checkUserAdded(str);
        let membersFilter = filterStr.match(regex);
        if (membersFilter && membersFilter.length > 0) {
          this.messageInput = this.messageInput.replace(
            membersFilter[membersFilter.length - 1],
            "@" + value.firstname + " "
          );

           this.mention.push({...value,mention:"@" + value.firstname});

          this.searchMemberArr = [];
        }
      }
    },
    submitReply() {
      let key = this.replyCommentData.key;
      let notifications = [];
      this.mention.map((v) => {
        notifications.push({ email: v.email, name: v.name });
      });
      let likeorder = parseInt(
        "9999" +
          moment()
            .utc()
            .add(this.userLogin.timezone, "hours")
            .format("YYYYMMDDHHmmss")
      );
      let data = {
        comments: 0,
        company: this.userLogin.company,
        createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
        like: 0,
        likeorder: likeorder,
        liked: false,
        mparent_id: this.sessionId,
        maprent_id2: this.replyCommentData.key,
        name:
          this.userLogin.firstname + " " + this.userLogin.lastname.charAt(0),
        notifications: notifications,
        type: "session",
        user: this.userLogin.email,
        value: this.messageInput,
      };

      let commentData = _.find(this.commentData, function (o) {
        return o.key == key;
      });
      commentData.subComment.push({
        ...data,
        creatorImageProfile: this.userLogin.profilepic_crop,
      });
      this.$store
        .dispatch("happilyvillageUniversity/replyComment", {
          sessionId: this.sessionId,
          comment: this.replyCommentData,
          message: this.messageInput,
          likeorder: likeorder,
          notifications:notifications,
        })
        .then(() => {
          this.messageInput = "";
          this.statusUpdate = true;
        });

      this.clearReplyData();
      this.clearReplyData();
    },
    submitMessage() {
      let notifications = [];
      this.mention.map((v) => {
        notifications.push({ email: v.email, name: v.name });
      });
      let likeorder = parseInt(
        "9999" +
          moment()
            .utc()
            .add(this.userLogin.timezone, "hours")
            .format("YYYYMMDDHHmmss")
      );

      let data = {
        comments: 0,
        company: this.userLogin.company,
        createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
        like: 0,
        likeorder: likeorder,
        liked: false,
        mparent_id: this.sessionId,
        name:
          this.userLogin.firstname + " " + this.userLogin.lastname.charAt(0),
        notifications: notifications,
        subComment: [],
        type: "session",
        user: this.userLogin.email,
        value: this.messageInput,
      };
      this.commentData.push({
        ...data,
        creatorImageProfile: this.userLogin.profilepic_crop,
      });
      this.$store
        .dispatch("happilyvillageUniversity/comment", {
          sessionId: this.sessionId,
          message: this.messageInput,
          likeorder: likeorder,
          notifications:notifications,
        })
        .then(() => {
          let commentData = _.find(this.commentData, function (o) {
            return !o.key;
          });
          commentData.key = this.commentId;
          this.messageInput = "";
          this.statusUpdate = true;
        });
    },
    showCommentModal(value) {
      let signup=[]
      const signups = Array.isArray(value.signup) ? value.signup : [];
      this.commentDetail.title= value.class_name;
      this.commentDetail.description= value.class_description;
      this.commentDetail.class_description= value.class_description;
      this.commentDetail.class_description_md= value.class_description_md;
      this.commentDetail.class_description_format= value.class_description_format;
      this.commentDetail.dateAndTime = value.class_datetime
        ? moment(value.class_datetime).format("MMMM DD, YYYY h:mm A")
        : "";
      this.commentDetail.location=value.class_location;
      this.commentDetail.duration=value.minutes;
      this.commentDetail.price=value.class_price;
      this.commentDetail.sessionLimit=value.class_limit
      this.commentDetail.commentsall=value.commentsall || 0
      this.commentDetail.creator= value.create_name || "";
      const createUser = value.create_user;
      const isCharacterPost =
        createUser === "happily_charracter" ||
        createUser === "happily_character" ||
        (typeof createUser === "string" &&
          createUser.toLowerCase().includes("happily")) ||
        !!(value.happily_user && value.happily_user !== "");
      if (isCharacterPost) {
        this.commentDetail.creatorImageProfile = value.happily_user || "";
        const parts = String(value.create_name || "").trim().split(/\s+/);
        this.commentDetail.firstname = parts[0] || "";
        this.commentDetail.lastname = parts[1] || "";
        this.commentDetail.creator = value.create_name || "";
      } else if (this.userAll[createUser]) {
        const u = this.userAll[createUser];
        this.commentDetail.creatorImageProfile =
          u.profilepic_crop || u.profilepic_small || u.profilepic || "";
        this.commentDetail.firstname = u.firstname;
        this.commentDetail.lastname = u.lastname;
        this.commentDetail.creator = value.create_name;
      } else {
        this.commentDetail.creatorImageProfile = "";
        this.commentDetail.firstname = "";
        this.commentDetail.lastname = "";
      }
      signups.forEach((v)=>{
        if(this.userAll[v.email]){
          signup.push({
            id: v.email,
            firstname:this.userAll[v.email].firstname,
            lastname: this.userAll[v.email].lastname,
            imageProfile:this.userAll[v.email].profilepic_crop,
        })
        }else {
          signup.push({
            id: v.email,
            firstname:"",
            lastname: "",
            imageProfile:"",
        })
        }
      })
      
      this.commentDetail.student=signup
 
      this.$store
        .dispatch("happilyvillageUniversity/getComment", { id: value.key })
        .then(() => {
          this.commentModal = true;
          this.sessionId = value.key;
          this.scrollToBottomComments();
        });
    },
    addSession() {
      this.cancelSessionModal();
      this.setUser(this.userLogin);
      this.sessionForm.creator = this.user.name;
      this.sessionForm.duration = 60;
      this.sessionForm.dateAndTime = this.getDefaultSessionDateTime();
      this.sessionModalStatus = true;
    },
    openProgramSessionComposerFromRoute() {
      if (!this.$route || !this.$route.query || this.$route.query.compose !== "program") {
        return;
      }
      this.addSession();
      this.huddleTag = [[PROGRAM_ONLY_KEY]];
      this.clearProgramComposerQuery();
    },
    clearProgramComposerQuery() {
      if (!this.$router || !this.$route || !this.$route.query) return;
      const query = { ...this.$route.query };
      delete query.compose;
      this.$router.replace({ query }).catch(() => {});
    },
    getDefaultSessionDateTime() {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      d.setHours(9, 0, 0, 0);
      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    setUser(userData) {
      this.user.firstname = userData.firstname;
      this.user.lastname = userData.lastname;
      this.user.name = userData.firstname + " " + userData.lastname.charAt(0);
      if (userData.profilepic_small) {
        this.user.pic = userData.profilepic_small;
      } else if (userData.profilepic_crop) {
        this.user.pic = userData.profilepic_crop;
      } else if (userData.profilepic) {
        this.user.pic = userData.profilepic;
      } else {
        this.user.pic = null;
      }
      
    },
    exportTable(val) {
      console.log("Export excel file" + val); // TODO: Export excel file funcion!
      if (val === "onlineCourses") {
        this.downloadSessionsBar = true;
        setTimeout(() => {
          this.downloadSessionsBar = false;
        }, 2000);
      } else if (val === "universitySesstions") {
        this.downloadCoursesBar = true;
        setTimeout(() => {
          this.downloadCoursesBar = false;
        }, 2000);
      }
    },
    randerBarChartUniversity() {
      var universityBarchart = this.$refs.universityBarchart;
      const months = [];
      const value = [];
      for (const x in this.university_graphmonth) {
        months.push(this.university_graphmonth[x].month);
        value.push(this.university_graphmonth[x].value);
      }
      // Reverse the arrays to show oldest months first
      months.reverse();
      value.reverse();

      if (universityBarchart) {
        this.loadingChartStatus = false;
        const universityBarChartData = {
          labels: months,
          datasets: [
            {
              label: "Learning Interactions",
              data: value,
              ...buildHVBarDataset('university'),
            },
          ],
        };
        this.university_bar_chart = new Chart(
          universityBarchart.getContext("2d"),
          {
            plugins: [ChartDataLabels],
            type: "bar",
            data: universityBarChartData,
            options: buildHVBarOptions('university'),
          }
        );
      }
    },
    sessionSort({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("happilyvillageUniversity/sortSesstions", [
          column.property,
          order,
        ]);
      }
    },
    handleCurrentSessionChange(val) {
      this.currentPage = val;
      this.$store.dispatch(
        "happilyvillageUniversity/currentSessionsChange",
        val
      );
    },
    typeingSearchSession() {
      this.$store.dispatch("happilyvillageUniversity/searchSessions", {
        value: this.inputSearchSession,
        typingTimeout: this.variable.typingTimeout,
      });
    },
    sessionSubmit() {
      let validateData = this.validateForm();
      if (validateData) {
        let form = [];
        form = this.normalizeSessionForm(_.clone(this.sessionForm));
        this.$store
          .dispatch("happilyvillageUniversity/createSession", {
            form: form,
            huddles: this.huddleTag,
          })
          .then(() => {
            this.sessionModalStatus = false;
            this.cancelSessionModal();
          });
        this.$message({
          type: "success",
          message: "New session has been created",
        });
      }
    },
    saveSession() {
      let validateData = this.validateForm();
      if (validateData) {
        let form = [];
        let id = _.clone(this.id);
        form = this.normalizeSessionForm(_.clone(this.sessionForm));
        this.$store
          .dispatch("happilyvillageUniversity/editSession", {
            form: form,
            id: id,
            huddles: this.huddleTag,
          })
          .then(() => {
            this.sessionModalStatus = false;
            this.cancelSessionModal();
          });
        this.$message({
          type: "success",
          message: "Session has been updated",
        });
      }
    },
    saveDraftSessionForm() {
      let validateData = this.validateForm();
      if (validateData) {
        setTimeout(() => {
          // remove timeout and Create functions no this line!
          this.sessionModalStatus = false;
          console.log("Saved Draft", this.sessionForm); // TODO: Save draft function!
        }, 500);
      }
    },
    normalizeSessionForm(form) {
      return {
        ...form,
        price: this.$utils("watchingTrim", form.price || "") ? Number(form.price) : 0,
        sessionLimit: this.normalizeOptionalParticipantCount(form.sessionLimit),
        sessionMinimum: this.normalizeOptionalParticipantCount(
          form.sessionMinimum
        ),
      };
    },
    normalizeOptionalParticipantCount(value) {
      return this.$utils("watchingTrim", value || "") ? Number(value) : 0;
    },
    handleVideoChange(file) {
      const raw = file && file.raw ? file.raw : null;
      this.sessionForm.videoFile = raw;
      this.sessionForm.videoFileList = file ? [file] : [];
      this.sessionForm.videoThumbnail = null;
      this.validateSessionForm.videoFile = false;
      // Best-effort thumbnail capture in the background. Failure leaves
      // uri_image empty; RN's VideoCard falls back to a generic thumb.
      if (raw) {
        captureVideoThumbnail(raw)
          .then((blob) => { this.sessionForm.videoThumbnail = blob; })
          .catch((err) => {
            this.sessionForm.videoThumbnail = null;
            console.warn('Video thumbnail capture failed:', err && err.message);
          });
      }
    },
    handleVideoRemove() {
      this.sessionForm.videoFile = null;
      this.sessionForm.videoFileList = [];
      this.sessionForm.videoThumbnail = null;
    },
    validateForm() {
      // Reset all per-field flags so validation is idempotent across calls.
      Object.keys(this.validateSessionForm).forEach((k) => {
        this.validateSessionForm[k] = false;
      });

      let statusForm = true;

      // Title + description are required for both class types.
      const sharedRequired = ["name", "description"];
      for (const key of sharedRequired) {
        const ok = this.$utils("watchingTrim", this.sessionForm[key] || "");
        if (!ok) {
          this.validateSessionForm[key] = true;
          statusForm = false;
        }
      }

      if (this.sessionForm.classType === CLASS_TYPE.VIDEO) {
        // Video branch: validate the source-specific media field only.
        if (this.sessionForm.videoSource === VIDEO_SOURCE.YOUTUBE) {
          if (!isValidYouTubeUrl(this.sessionForm.videoUrl)) {
            this.validateSessionForm.videoUrl = true;
            statusForm = false;
          }
        } else if (this.sessionForm.videoSource === VIDEO_SOURCE.UPLOAD) {
          // Allow editing without re-uploading: if we already have media on
          // the original doc (editSessionsStatus + no new file), accept it.
          // For create, require a fresh File.
          if (!this.sessionForm.videoFile && !this.editSessionsStatus) {
            this.validateSessionForm.videoFile = true;
            statusForm = false;
          }
        }
      } else {
        // Live branch: price and topic are optional; blank price saves as 0.
        const liveRequired = [
          "dateAndTime",
          "duration",
          "location",
        ];
        for (const key of liveRequired) {
          const ok = this.$utils("watchingTrim", this.sessionForm[key] || "");
          if (!ok) {
            this.validateSessionForm[key] = true;
            statusForm = false;
          }
        }
      }

      return statusForm;
    },
    SignUpsModal(val) {
      this.modalSignUps.class_name = val.class_name;
      this.modalSignUps.create_name = val.create_name;
      this.modalSignUps.signup = val.signup.length;
      this.modalSignUps.class_limit = val.class_limit;
      if (val.signup.length > 0) {
        let studentArr = [];
        for (const x in val.signup) {
          let _item = val.signup[x];
          let emailKey = _item.email.replace(/\./g, "||");
          _item.firstname = this.allusers[emailKey]
            ? this.allusers[emailKey].firstname
            : "";
          _item.lastname = this.allusers[emailKey]
            ? this.allusers[emailKey].lastname
            : "";
          if (this.allusers[emailKey]) {
            if (this.allusers[emailKey]["profilepic_small"]) {
              _item.image = this.allusers[emailKey]["profilepic_small"];
            } else if (this.allusers[emailKey]["profilepic_crop"]) {
              _item.image = this.allusers[emailKey]["profilepic_crop"];
            } else if (this.allusers[emailKey]["profilepic"]) {
              _item.image = this.allusers[emailKey]["profilepic"];
            } else {
              _item.image = "";
            }
          }
          studentArr.push(_item);
        }
        this.modalSignUps.student = studentArr;
      } else {
        this.modalSignUps.student = [];
      }
      // this.modalSignUps.student = val.signup; // Add students data here <<<
      this.dialogSignUps = true;
    },
    removeYear(dateTime) {
      if (!dateTime) return "-";
      return format(dateTime, "MMM D [at] H:mm A");
    },
    reformatForCalenda(str) {
      let removeComma = str.split(",");
      let removeAt = removeComma.join("").split(" at");
      return removeAt.join(",");
    },
    handleSessionActionCommand(command, row) {
      switch (command) {
        case "duplicate":
          this.cloneMenu(row, "duplicate");
          break;
        case "edit":
          this.cloneMenu(row, "edit");
          break;
        case "delete":
          this.deleteMenu(row);
          break;
      }
    },
    cloneMenu(value, select) {
      // console.log('value',value)
      // console.log('this.creatorList',this.creatorList)
      this.resetValidateForm();
      if(value.create_user=='happily_charracter'){
        const creetor=_.find(this.creatorList, function (el) {
          return el.character_name == value.create_name_character;
        });
        this.sessionForm.creator = creetor.name;
      }else{
        this.sessionForm.creator =value.create_name 
      }
      const huddles=[]
      if(value.huddles){
        value.huddles.map((v)=>{
          let huddle = _.find(this.huddleTagData, function (item) {
            return item.value == v.key;
          });
          if(huddle) {
            huddles.push([huddle.value]);
          }
        });

      }
      //console.log('huddles',huddles)
      this.huddleTag = huddles;


      this.sessionForm.name = value.class_name || "";
      this.sessionForm.description = initialEditorValue(value, "class_description");
      this.sessionForm.duration = value.minutes || null;
      this.sessionForm.location = value.class_location || "";
      this.sessionForm.sessionLimit = value.class_limit || null;
      this.sessionForm.sessionMinimum = value.class_minimum || null;
      this.sessionForm.price = (value.class_price || value.class_price == 0 || value.class_price == '0') ? value.class_price : null;
      this.sessionForm.topic = value.topic_id || null;
      this.sessionForm.commentPermission = value.comment_type;
      this.sessionForm.google_event_id = value.google_event_id || null;
      // Video fields: missing class_type means a legacy live session.
      this.sessionForm.classType = value.class_type === CLASS_TYPE.VIDEO
        ? CLASS_TYPE.VIDEO
        : CLASS_TYPE.LIVE;
      this.sessionForm.videoSource = value.video_source === VIDEO_SOURCE.UPLOAD
        ? VIDEO_SOURCE.UPLOAD
        : VIDEO_SOURCE.YOUTUBE;
      this.sessionForm.videoUrl = value.video_url || "";
      this.sessionForm.videoFile = null;
      this.sessionForm.videoFileList = [];
      this.sessionForm.videoThumbnail = null;
      this.sessionForm.xpAmount =
        typeof value.xp_amount === "number" && value.xp_amount > 0
          ? value.xp_amount
          : VIDEO_XP_REWARD;
      this.setUser(this.userLogin);
      if (select === "edit") {
        this.id = value.key;
        this.sessionForm.dateAndTime = value.class_datetime || "";
        this.editSessionsStatus = true;
      } else {
        this.id = "";
        this.sessionForm.dateAndTime = this.getDefaultSessionDateTime();
        this.editSessionsStatus = false;
      }
      this.sessionModalStatus = true;
    },
    resetValidateForm() {
      this.validateSessionForm.name = false;
      this.validateSessionForm.description = false;
      this.validateSessionForm.dateAndTime = false;
      this.validateSessionForm.duration = false;
      this.validateSessionForm.location = false;
      this.validateSessionForm.sessionLimit = false;
      this.validateSessionForm.sessionMinimum = false;
      this.validateSessionForm.price = false;
      this.validateSessionForm.topic = false;
    },
    deleteMenu(value) {
      this.$confirm(
        `Are you sure you would like to proceed with "${value.class_name}"? deleting This action cannot be undone.`,
        "Confirm to Delete",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("happilyvillageUniversity/deleteSession", value);
          this.$message({
            type: "success",
            message: "Delete completed",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    cancelSessionModal() {
      this.id = "";
      this.editSessionsStatus = false;
      this.sessionForm.name = "";
      this.sessionForm.description = "";
      this.sessionForm.dateAndTime = "";
      this.sessionForm.duration = null;
      this.sessionForm.location = "";
      this.sessionForm.sessionLimit = null;
      this.sessionForm.sessionMinimum = null;
      this.sessionForm.price = null;
      this.sessionForm.topic = null;
      this.sessionForm.commentPermission = 1;
      this.sessionForm.google_event_id = null;
      // Video fields default back to "new live session".
      this.sessionForm.classType = CLASS_TYPE.LIVE;
      this.sessionForm.videoSource = VIDEO_SOURCE.YOUTUBE;
      this.sessionForm.videoUrl = "";
      this.sessionForm.videoFile = null;
      this.sessionForm.videoFileList = [];
      this.sessionForm.xpAmount = VIDEO_XP_REWARD;

      this.user.pic = null;
      this.user.firstname = "Firstname";
      this.user.lastname = "Lastname";
      this.user.name = "Firstname L";

      this.resetValidateForm();
    },
    spanBgColor(value) {
      if (value.programOnly) {
        return "span-tag span-program-only";
      } else if (value.house) {
        switch (value.key) {
          case "-LWOr-XsbZM2digYl1QL":
            return "span-tag bg-1d97f2";
            break;
          case "-LWPrOElCYViBd6j6qP-":
            return "span-tag bg-ffbf1f";
            break;
          default:
            return "span-tag bg-ea183c";
        }
      } else if (value.team) {
        return "span-tag span-normal";
      }
    },
    spanTextTag(value) {
      if (value.programOnly) {
        return "Program only";
      } else if (value.house) {
        switch (value.key) {
          case "-LWOr-XsbZM2digYl1QL":
            return "Delphinus";
            break;
          case "-LWPrOElCYViBd6j6qP-":
            return "Leonos";
            break;
          default:
            return "Corvus";
        }
      } else if (value.team) {
        return value.value;
      }
    },
    filterToFunction(node, keyword) {
      let space = keyword.split(" ");
      let comma = keyword.split(",");
      let commaAndSpace = keyword.split(", ");
      let keywordArr = comma;
      if (space.length > comma.length) {
        keywordArr = space;
      } else if (
        commaAndSpace.length > comma.length ||
        commaAndSpace.length > space.length
      ) {
        keywordArr = commaAndSpace;
      }
      if (keywordArr.length > 1) {
        for (let i = 0; i < keywordArr.length; i++) {
          if (node.data.toType == "user") {
            if (
              node.data.firstname
                .toLowerCase()
                .indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname
                .toLowerCase()
                .indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (keywordArr[i].trim() === node.data.email) {
              this.dynamicValidateForm.cascaderTo.push([
                "user_" + node.data.email,
              ]);
              this.changeDataTo(this.dynamicValidateForm.cascaderTo);
              this.refreshInput = false;
              setTimeout(() => {
                this.refreshInput = true;
              }, i * 75);
            }
          }
        }
        setTimeout(() => {
          this.$refs.refTo.inputValue = "";
          this.$refs.refTo.dropDownVisible = false;
        }, keywordArr.length * 75);
        this.$refs.refTo.handleClear();
      } else {
        if (node.data.toType == "user") {
          if (
            node.data.firstname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (
            node.data.lastname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (keyword.trim() === node.data.email) {
            this.dynamicValidateForm.cascaderTo.push([
              "user_" + node.data.email,
            ]);
            this.refreshInput = false;
            this.changeDataTo(this.dynamicValidateForm.cascaderTo);
            setTimeout(() => {
              this.refreshInput = true;
            }, 100);
            this.$refs.refTo.inputValue = "";
            this.$refs.refTo.dropDownVisible = false;
            this.$refs.refTo.handleClear();
          }
        } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
        }
      }
    },
     prettyDate(datetime) {
      if (!datetime) return;
      const now = new Date();
      const target = new Date(datetime).toISOString().split('T')[0];
      var hours = Math.abs(new Date() - new Date(datetime)) / 36e5;
      now.setDate(now.getDate() - 1);
      const yesterday = now.toISOString().split('T')[0];

      // @see https://date-fns.org/v1.29.0/docs/format
      let result = format(datetime, "MMM D");
      const time = format(datetime, "h:mm A");
        if(hours<1){
          var diffMins = Math.round(((Math.abs(new Date() - new Date(datetime))  % 86400000) % 3600000) / 60000);
          result=diffMins+" minute ago"
        }else if(hours<24){
          result=Math.round(hours)+" hours ago"
        }else if (target == yesterday) {
        result = "Yesterday";
        result += ` at ${time}`;
        }else{
           result += ` at ${time}`;
        }

    
      

      return result;
    },
    canEditPost(post) {
      
      // Check if user owns the post
      const isCreator = post.create_user === this.userLogin.email || post.email_create === this.userLogin.email;
      
      // Check if it's a Happily Character post (various formats)
      const isHappilyCharacterPost = 
        post.create_user === 'happily_charracter' || 
        post.create_user === 'happily_character' ||
        (post.create_user && typeof post.create_user === 'string' && post.create_user.toLowerCase().includes('happily')) ||
        (post.happily_user && post.happily_user !== '');
      
      // Debug logging - remove after testing
      if (isHappilyCharacterPost) {
        // console.log('University Happily Character Post Found:', {
        //   create_user: post.create_user,
        //   email_create: post.email_create,
        //   happily_user: post.happily_user,
        //   create_name: post.create_name
        // });
      }
      
      // Allow editing if user is creator OR if it's a Happily Character post
      return isCreator || isHappilyCharacterPost;
    },
  },
};
</script>

<style lang="scss" scoped>
.program-only-hint {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 8px 0;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid rgba(108, 48, 204, 0.18);
  border-radius: 8px;
}
.program-only-hint-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: #f2ecfb;
  color: #6c30cc;
  font-size: 13px;
}
.program-only-hint-copy {
  flex: 1;
  min-width: 0;
}
.program-only-hint-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.005em;
  line-height: 1.35;
}
.program-only-hint-sub {
  margin-top: 3px;
  font-size: 12px;
  color: #626262;
  line-height: 1.5;
}
.span-program-only {
  background: #f2ecfb !important;
  color: #6c30cc !important;
}

.barchart-style {
  border-radius: 4px;
}
.sub-title {
  text-transform: capitalize;
}

.university-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }

  ::v-deep .el-tabs__nav-wrap {
    margin-bottom: 0;
  }

  ::v-deep .el-tabs__item {
    padding: 0 20px;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    font-weight: 500;
  }

  ::v-deep .el-tabs__content {
    padding-top: 0;
  }
}

.tab-label {
  font-size: 16px;
  font-weight: 500;
}
.bg-black-001 {
  background-color: rgba(000, 000, 000, 0.01);
}
.btn-add.small {
  font-size: 14px;
  height: 33px;
  width: 160px;
}
.icon-export {
  position: absolute;
  top: 3px;
  padding-left: 32px;
}
.grid-2-sesstion {
  display: grid;
  grid-template-columns: 400px auto;
}
.grid-2-sesstion.grid-2-detail {
  grid-template-columns: 1.3fr 1fr;
}
.grid-left {
  min-height: 840px;
  // No max-height: the dialog's right column can exceed 924px in LIVE
  // mode (Date/Duration + Location/Price + Min/Max + Topic/Permissions
  // rows). CSS grid's default align-items: stretch will then size the
  // left column to match — capping it leaves an empty strip below the
  // preview content.
  background-color: #eef0f5; // matches aq-preview-backdrop
  padding: 32px 36px;
  > .body {
    padding: 0;
  }
}
.grid-left .aq-preview-eyebrow {
  margin-bottom: 20px;
}
.hv-dialog-title {
  font-size: 20px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.01em;
  margin-bottom: 18px;
}
.grid-right {
  padding: 60px 40px;
  background-color: #f8f8f8;
}
.bg-skeleton {
  background-color: #d8d8d8;
  border-radius: 3px;
  width: 100%;
}
.height-32 {
  height: 32px;
}
.height-25 {
  height: 25px;
}
.height-20 {
  height: 20px;
  width: 90px;
}
.height-cycle {
  border-radius: 10px;
  height: 20px;
  width: 20px;
}
.coin {
  &::before {
    content: "";
    background: #ffc75f;
    border-radius: 9px;
    height: 18px;
    width: 18px;
    position: absolute;
    left: -9px;
    top: -2px;
  }
}
.price-box {
  border-radius: 100px;
  padding: 5px 10px 5px 10px;
  border: 1px solid #00000029;
  position: absolute;
}
.mockup-icon {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin: 6px 6px 0 0;
  background-color: #ededed;
}
.mini-icon {
  width: 16px;
  height: 16px;
}
.table-happily-village {
  font-size: 13px;
}
.recipients-modal {
  padding-left: 40px;
  padding-bottom: 16px;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 6px #00000014;
  opacity: 1;
}
.members-recipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 0 0;
  margin: 0 0 0 16px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
}
.span-tag {
  margin-right: 6px;
}
.loading-box {
  border-radius: 4px;
  height: 48px;
  width: 100%;
  background-color: #f0f0f0;
  > .file {
    background-color: #e6e6e6;
    width: 48px;
    height: 48px;
    border-radius: 4px 0 0 4px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
  }
  > .name {
    width: calc(100% - 112px);
  }
  > .remove {
    transition: 0.3s;
    position: absolute;
    right: 0;
    width: 48px;
    font-size: 16px;
    &:hover > i {
      box-shadow: 0 0 10px 2px #f0f0f0;
    }
  }
}

.comment-contrainer {
  position: relative;
  padding: 60px 40px 40px;
  .comment-card {
    height: 538px;
    background-color: #fff;
    box-shadow: 0px 2px 4px #00000029;
    .comment-box {
      height: 490px;
      .comment {
        min-height: calc(70px - 36px);
        padding: 18px;
        display: grid;
        grid-template-columns: auto 60px;
        .content-comment {
          display: grid;
          grid-template-columns: 44px auto;
        }
        .content-comment-sub {
          display: grid;
          grid-template-columns: 24px 44px auto;
        }
        .img-preview {
          width: auto;
          max-width: 200px;
          max-height: 400px;
          object-fit: cover;
          background-color: rgba($color: #afafaf, $alpha: 0.4);
        }
      }
    }
    .no-comment {
      padding-top: 60px;
      text-align: center;
      color: #404243;
      font-size: 14px;
    }
    .input-container {
      background-color: #ebebeb;
      padding: 0 16px;
      height: 48px;
      display: grid;
      grid-template-columns: 44px auto 56px;
      .input-contain {
        background-color: #fff;
        border-radius: 3px;
        height: 30px;
        .reply-tag {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 3px;
          color: #afafaf;
          font-size: 11px;
          font-weight: 700;
          padding: 3px 6px 2px;
        }
      }
      .input-box {
        background-color: #fff;
        border: 0;
        border-radius: 3px;
        outline: 0;
        height: 30px;
        padding: 0 8px;
        width: calc(100% - 16px);
      }
      .mention-container {
        background-color: #fff;
        position: absolute;
        top: 0;
        max-height: 140px;
        padding: 2px 0;
        width: calc(100%);
        border-radius: 2px;
        box-shadow: 1px 1px 4px #ccc;
        .memeber-box {
          padding: 0 8px;
          height: 40px;
          font-size: 13px;
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            background-color: rgba($color: #ccc, $alpha: 0.4);
          }
        }
      }
    }
  }
}

// University Sessions Table - Fixed Actions Column with Scrollable Content
.university-table-wrapper {
  .university-sessions-table {
    // Enable horizontal scrolling for table content
    overflow-x: auto;
    border-radius: 8px;
    
    // Table body styling
    .el-table__body-wrapper {
      .el-table__row {
        td {
          // Name styling - matching campaigns reference
          .name-medium {
            font-weight: 700;
            color: #111827;
            line-height: 1.4;
          }

          // Link styling for engagement - using brand primary color
          .link, .engagement-link {
            color: #6C30CC;
            font-weight: 500;
            transition: color 0.2s ease;
            cursor: pointer;

            &:hover {
              color: #5A28A8;
            }
          }
        }
      }
    }

    // Enhanced tag styling for Happily badges
    .span-tag {
      font-size: 11px;
      font-weight: 600;
      padding: 3px 8px;
      border-radius: 12px;
      margin-right: 4px;
      letter-spacing: 0.3px;
    }
  }
}

// Action menu styles - matching campaigns reference
.campaign-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.campaign-actions-trigger {
  width: 32px;
  height: 32px;
  border: 1px solid #E5E7EB;
  border-radius: 999px;
  background: #FFFFFF;
  color: #4B5563;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.campaign-actions-trigger:hover,
.campaign-actions-trigger:focus {
  background: #F9FAFB;
  border-color: #D1D5DB;
  color: #111827;
  outline: none;
}

.campaign-actions-trigger i {
  font-size: 16px;
  font-weight: 700;
}

.hv-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid #eef0f5;
}
.hv-dialog-footer .el-button {
  min-width: 120px;
}
/* Brand the primary submit button purple — the Element UI default
   primary cyan drifted from the canonical .btn-6C30CC pattern used
   in programs/* and members/*. Scoping to .hv-dialog-footer keeps
   other primary buttons elsewhere on the page unchanged. */
.hv-dialog-footer .el-button--primary {
  background-color: #6c30cc !important;
  border-color: #6c30cc !important;
  color: #fff !important;
  box-shadow: 0 1px 2px rgba(108, 48, 204, 0.18) !important;
}
.hv-dialog-footer .el-button--primary:hover,
.hv-dialog-footer .el-button--primary:focus {
  background-color: #522698 !important;
  border-color: #522698 !important;
  color: #fff !important;
}

</style>

<style lang="scss">
// Global override for engagement link colors in University Sessions
#university .university-sessions-table {
  .link,
  .engagement-link,
  .fc-00B7EE,
  [style*="color: #00B7EE"] {
    color: #6C30CC !important;

    &:hover {
      color: #5A28A8 !important;
    }
  }
}

#sessionModal {
  .comments-modal {
    .el-dialog__header {
      padding: 0;
      z-index: 2;
      position: relative;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .grid-2-auto {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  .title {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #8a8a8a;
    margin: 18px 0 6px;
  }
  // Only the very first label in the form root is flush — labels
  // inside conditional wrappers or grid columns must keep the 18px
  // top margin for consistent rhythm. The `>` keeps :first-of-type
  // from matching the first div inside any v-if wrapper.
  & > .title:first-of-type {
    margin-top: 0;
  }
  .el-input__inner,
  .el-textarea__inner {
    border: 1px solid rgba(26, 26, 46, 0.08);
    background: #fff;
    font-weight: 400;
    border-radius: 8px;
    transition: border-color .2s ease, box-shadow .2s ease;
  }
  .el-input__inner:focus,
  .el-textarea__inner:focus {
    border-color: #6c30cc;
    box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.1);
  }
  .validate-input.el-input > .el-input__inner,
  .el-textarea.validate-input > .el-textarea__inner {
    border-color: #f56c6c;
  }
  .validate-input.el-input > .el-input__inner:focus,
  .el-textarea.validate-input > .el-textarea__inner:focus {
    box-shadow: 0 0 0 3px rgba(245, 108, 108, 0.1);
  }
  .md-editor .el-textarea__inner,
  .md-editor .el-textarea__inner:focus {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    background: #fff;
    min-height: auto;
  }
  .el-input__inner::placeholder,
  .el-textarea__inner::placeholder {
    color: rgba(26, 26, 46, 0.35);
  }
  .name > .el-input__inner {
    font-size: 16px;
    font-weight: 500;
    height: 44px;
  }
  .el-input__inner {
    font-size: 14px;
    height: 40px;
    line-height: 40px;
  }
  .el-textarea__inner {
    padding: 14px 16px;
    font-size: 14px;
    line-height: 1.55;
    min-height: 110px;
    word-break: normal;
    overflow-wrap: break-word;
  }
  .el-date-editor.el-input,
  .el-select {
    width: 100%;
  }
  .el-date-editor .el-input__inner {
    padding-left: 36px;
  }
  .profiel-selected {
    position: absolute;
    top: 4px;
    padding: 2px 0px;
    left: 20px;
  }
  .creator-profile .el-input__inner {
    padding-left: 60px;
    height: 48px;
    line-height: 48px;
  }
}

/* Session modal layout + preview polish */
#university .remove-padding-modal .el-dialog,
.remove-padding-modal .el-dialog {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(18, 12, 40, 0.18);
}
#university .remove-padding-modal .el-dialog__header,
.remove-padding-modal .el-dialog__header {
  padding: 0;
}
#university .remove-padding-modal .el-dialog__headerbtn,
.remove-padding-modal .el-dialog__headerbtn {
  top: 16px;
  right: 16px;
  z-index: 3;
}
#university .remove-padding-modal .el-dialog__headerbtn .el-dialog__close,
.remove-padding-modal .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.9);
  font-size: 18px;
}
#university .remove-padding-modal .el-dialog__body,
.remove-padding-modal .el-dialog__body {
  padding: 0;
}

/* Preview word-break: never split mid-word */
#university .grid-left .word-break,
.remove-padding-modal .grid-left .word-break,
#university .grid-left .pre-line,
.remove-padding-modal .grid-left .pre-line {
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: auto;
}

/* Lives in the unscoped block because Vue's scope hash doesn't attach
   to a child component's internal DOM (.el-radio-button__inner,
   .el-input-number__*), so scoped rules silently miss them. */
#sessionModal .el-radio-button__inner {
  border-color: #e2e4ea;
  background: #fff;
  color: #4a4a4a;
  font-weight: 600;
  padding: 8px 18px;
  transition: color .15s ease, background .15s ease, border-color .15s ease;
  box-shadow: none;
}
#sessionModal .el-radio-button:hover .el-radio-button__inner {
  color: #6c30cc;
}
#sessionModal .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #f2ecfb;
  color: #6c30cc;
  border-color: #c8b3e6;
  box-shadow: -1px 0 0 0 #c8b3e6;
}
#sessionModal .xp-picker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
#sessionModal .xp-picker .el-button--default {
  background: #fff;
  border-color: #e2e4ea;
  color: #4a4a4a;
  font-weight: 600;
}
#sessionModal .xp-picker .el-button--default:hover {
  color: #6c30cc;
  border-color: #c8b3e6;
  background: #faf7fe;
}
#sessionModal .xp-picker .el-button--primary {
  background: #f2ecfb;
  border-color: #c8b3e6;
  color: #6c30cc;
  font-weight: 700;
  box-shadow: none;
}
#sessionModal .xp-picker .el-input-number {
  margin-left: 4px;
  width: 130px;
}
#sessionModal .xp-picker .el-input-number .el-input__inner {
  border-color: #e2e4ea;
  border-radius: 8px;
  font-weight: 600;
  color: #4a4a4a;
  background: #fff;
}
#sessionModal .xp-picker .el-input-number .el-input__inner:focus,
#sessionModal .xp-picker .el-input-number.is-active .el-input__inner {
  border-color: #c8b3e6;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.1);
}
#sessionModal .xp-picker .el-input-number__decrease,
#sessionModal .xp-picker .el-input-number__increase {
  background: #fff;
  color: #6c30cc;
}
#sessionModal .xp-picker .el-input-number__decrease:hover:not(.is-disabled),
#sessionModal .xp-picker .el-input-number__increase:hover:not(.is-disabled) {
  color: #522698;
  background: #f2ecfb;
}
</style>
